(function () {
  const sticky = document.getElementById('pw-sticky-atc');
  if (!sticky) return;

  const btn = sticky.querySelector('[data-pw-sticky-btn]');
  const closeBtn = sticky.querySelector('[data-pw-sticky-close]');
  const img = sticky.querySelector('[data-pw-sticky-img]');
  const title = sticky.querySelector('[data-pw-sticky-title]');
  const price = sticky.querySelector('[data-pw-sticky-price]');

  // MUST exist in your product template (you already added it)
  const startSentinel = document.getElementById('pw-atc-sentinel');

  // --- helpers ---
  function show() {
    if (sessionStorage.getItem('pwStickyClosed') === '1') return;
    sticky.classList.add('is-visible');
    sticky.setAttribute('aria-hidden', 'false');
  }

  function hide() {
    sticky.classList.remove('is-visible');
    sticky.setAttribute('aria-hidden', 'true');
  }

  function isPastStartSentinel() {
    if (!startSentinel) return false;
    const r = startSentinel.getBoundingClientRect();
    // once sentinel has moved above the top of viewport, we're "past FBT"
    return r.top <= 0;
  }

  function footerLiftPx() {
    // lift sticky up when footer comes into view, WITHOUT flicker
    const footer =
      document.querySelector('#shopify-section-footer') ||
      document.querySelector('footer') ||
      document.querySelector('.footer');

    if (!footer) return 0;

    const fr = footer.getBoundingClientRect();
    const overlap = window.innerHeight - fr.top;
    // if footer is entering viewport, overlap > 0, lift sticky above it (+16 buffer)
    return overlap > 0 ? Math.ceil(overlap + 16) : 0;
  }

  // stable CSS var update (reduces bouncy feel)
  let lastLift = -999;
  function applyLift() {
    const lift = footerLiftPx();
    // only write when it really changes (prevents 1px jitter)
    if (Math.abs(lift - lastLift) >= 2) {
      sticky.style.setProperty('--pw-sticky-lift', lift + 'px');
      lastLift = lift;
    }
  }

  function updateVisibility() {
    // show only AFTER FBT sentinel
    if (!isPastStartSentinel()) {
      hide();
      applyLift();
      return;
    }

    // optional: if user closed it, keep hidden
    if (sessionStorage.getItem('pwStickyClosed') === '1') {
      hide();
      applyLift();
      return;
    }

    show();
    applyLift();
  }

  function findMainProductForm() {
    return (
      document.querySelector('product-form form[action^="/cart/add"]') ||
      document.querySelector('form[action^="/cart/add"]')
    );
  }

  function findMainATCButton() {
    const form = findMainProductForm();
    if (!form) return null;
    return form.querySelector('button[type="submit"], button[name="add"], input[type="submit"]');
  }

  function setupATC() {
    if (!btn) return;
    btn.addEventListener('click', () => {
      const mainBtn = findMainATCButton();
      if (!mainBtn) return;
      mainBtn.click();
    });
  }

  function setupClose() {
    if (!closeBtn) return;
    closeBtn.addEventListener('click', () => {
      sessionStorage.setItem('pwStickyClosed', '1');
      hide();
    });
  }

  function findProductMediaImage() {
    const containers = [
      '.product__media',
      '.product-media',
      '.product-gallery',
      '.media-gallery',
      '.product__media-list',
      '.product__media-wrapper'
    ];

    for (const sel of containers) {
      const c = document.querySelector(sel);
      if (!c) continue;
      const candidate = c.querySelector('img[src], img[srcset], img[data-src]');
      if (candidate) return candidate;
    }
    return null;
  }

  function setupVariantSync() {
    const h1 = document.querySelector('h1');
    if (h1 && title) title.textContent = h1.textContent.trim();

    const priceEl =
      document.querySelector('[data-product-price]') ||
      document.querySelector('.price__regular, .price-item--regular, .price, .product__price');
    if (priceEl && price) price.innerHTML = priceEl.innerHTML;

    const mainImg = findProductMediaImage();
    if (mainImg && img) {
      const src = mainImg.currentSrc || mainImg.src;
      if (src) img.src = src;
    }
  }

  // --- run (and re-run safely) ---
  let ticking = false;
  function onScroll() {
    if (ticking) return;
    ticking = true;
    requestAnimationFrame(() => {
      ticking = false;
      updateVisibility();
    });
  }

  function init() {
    setupATC();
    setupClose();
    setupVariantSync();

    // initial
    updateVisibility();

    // scroll/resize
    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onScroll, { passive: true });

    // theme editor safety
    document.addEventListener('shopify:section:load', () => {
      updateVisibility();
      setupVariantSync();
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();